import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { IamBackend } from '@/lib/BackendUrls';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { formatString } from '@/utils/format';

import { ResourcePermissions } from '../types/types';

export interface GetResourcePermissionParams {
  resourceType: string;
  resourceId: string | null;
}

export function getResourcePermission({
  resourceType,
  resourceId,
}: GetResourcePermissionParams): Promise<ResourcePermissions> {
  return acceso360Client
    .get(
      formatString(
        IamBackend.users.me.resource_permissions.one.byResourceId,
        resourceType,
        resourceId
      )
      // `/iam/api/v1/users/me/resource_permissions/${resourceType}/${resourceId}`
    )
    .then(({ data }) => data);
}

type QueryFnType = typeof getResourcePermission;

interface UseResourcePermissionParams {
  resourceType: string;
  resourceId: string | null;
  config?: QueryConfig<QueryFnType>;
}

export function useResourcePermission({
  resourceType,
  resourceId,
  config = {},
}: UseResourcePermissionParams) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    enabled: !!resourceType && !!resourceId,
    queryKey: [resourceType, resourceId],
    queryFn() {
      return getResourcePermission({ resourceType, resourceId });
    },
  });
}
